import React, { useEffect } from 'react';
import { Table, Empty, Card, Input, Button, Radio, Popover, Pagination } from 'antd';
import { IoIosAddCircle } from "react-icons/io";
import { fetchData } from '../../helper/api';
import { formatCurrency } from '../../helper/formatCurrency';
import ModalAddBusiness from './ModalAddBusiness';
import ActionBusiness from './ActionBusiness';
import { useLocation, useHistory } from 'react-router-dom';
import moment from 'moment';
import cleanPhoneNumber from '../../helper/cleanPhoneNumber';

function Index(props) {
    const [dataSource, setDataSource] = React.useState([]);
    const [dataFollowUp, setDataFollowUp] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState("");
    const [trigerFetchData, setTrigerFetchData] = React.useState(false);
    const [radioButton, setRadioButton] = React.useState('index');

    const location = useLocation();
    const history = useHistory();

    const [openModalAdd, setOpenModalAdd] = React.useState(false);

    const handleOpenModalAdd = () => {
        setOpenModalAdd(true);
    }

    const onSearch = (value) => {
        setSearchValue(value);
    }

    const mappingDataToDataSource = (data) => {
        return data.map((item, index) => {
            return {
                ...item,
            };
        });
    }
    const mappingDataFUToDataSource = (data) => {
        return data.map((item, index) => {
            return {
                id: item.businessId,
                name: item.businessName,
                total_transaction: item.totalTransactions,
                last_transaction: moment(item.lastTransactionDate).format('DD MMM YYYY'),
                days_since_last_transaction: item.daysSinceLastTransaction,
                businessData: item.businessData,
            };
        });
    }

    useEffect(() => {
        const searchLocation = location.search;
        const newSearchLocation = searchLocation.replace(/&add_update=\d/, "");
        history.push({
            ...location,
            search: newSearchLocation,
        });
        // Fetch data
        let url = `/businesses?search=${encodeURIComponent(searchValue)}`;

        if (searchValue === "") {
            url = `/businesses`;
        }

        fetchData(url)
            .then((res) => {
                const data = res.data.data;
                const dataSource = mappingDataToDataSource(data);
                setDataSource(dataSource);
            })
            .catch((err) => {
                console.log(err);
            });

    }, [location.search, trigerFetchData, searchValue])


    const column = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: 'PIC Name',
            dataIndex: 'pic_name',
            key: 'pic_name',
        },
        {
            title: 'PIC Phone',
            dataIndex: 'pic_phone',
            key: 'pic_phone',
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
            render: (text) => (
                <div style={{ width: '200px', maxWidth: '200px', overflow: 'hidden', whiteSpace: 'pre-line' }}>
                    {text}
                </div>
            ),
        },
        {
            title: 'Is Active',
            dataIndex: 'is_active',
            key: 'is_active',
            render: (text) => (
                <div style={{ overflow: 'hidden', whiteSpace: 'pre-line' }}>
                    {text === "active" ? "Active" : "Inactive"}
                </div>
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <ActionBusiness record={record} trigerFetchData={trigerFetchData} setTrigerFetchData={setTrigerFetchData} />
            ),
        },
    ]


    const columnFollowUp = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Total Transaction',
            dataIndex: 'total_transaction',
            key: 'total_transaction',
        },
        {
            title: 'Last Transaction',
            dataIndex: 'last_transaction',
            key: 'last_transaction',
        },
        {
            title: 'Days Since Last Transaction',
            dataIndex: 'days_since_last_transaction',
            key: 'days_since_last_transaction',
            render: (text) => (
                <div style={{ overflow: 'hidden', whiteSpace: 'pre-line' }}>
                    {text} days ago
                </div>
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <div className='flex gap-2'>
                    <Button className="items-center flex justify-center text-white bg-green-600" onClick={() => {
                        window.open(`https://web.whatsapp.com/send?phone=${cleanPhoneNumber(record.businessData?.phone)}`, '_blank');
                    }}>WA Web</Button>
                    <Button className="items-center flex justify-center text-white bg-green-400" onClick={() => {
                        window.open(`https://api.whatsapp.com/send?phone=${cleanPhoneNumber(record.businessData?.phone)}`, '_blank');
                    }}>WA Apps</Button>
                </div>
            ),
        },
    ]

    const optionRadioButton = [
        {
            label: 'Data Business',
            value: 'index',
        },
        {
            label: 'Follow Up',
            value: 'follow_up',
        }
    ]

    return (
        <>
            <ModalAddBusiness open={openModalAdd} setOpen={setOpenModalAdd} trigerFetchData={trigerFetchData} setTrigerFetchData={setTrigerFetchData} />
                <Card
                    bordered={false}
                    className="criclebox tablespace mb-4"
                    title={
                        <div style={{ display: "flex", gap: "20px" }}>
                            <h4>Business</h4>
                            <Input
                                style={{ width: "200px", fontSize: "12px" }}
                                placeholder="Search Name / Item / Service"
                                size="small"
                                onPressEnter={(e) => {
                                    if (e.key === 'Enter') {
                                        onSearch(e.target.value); // Gantilah dengan nama fungsi pencarian Anda
                                    }
                                }}
                            />
                        </div>
                    }
                    extra={
                        <div style={{ display: "flex", gap: "20px" }}>
                            <Button className="items-center flex justify-center text-white bg-blue-400" onClick={() => handleOpenModalAdd()}>
                                <IoIosAddCircle style={{ fontSize: "20px" }} />
                                Add Business
                            </Button>
                        </div>
                    }
                >
                    <div className="table-responsive">
                        <Table
                            columns={column}
                            dataSource={dataSource}
                            pagination={{
                                position: ['bottomCenter'],
                                pageSize: 10,
                                showSizeChanger: true,
                                pageSizeOptions: ['5', '10', '20', '30', '40'],
                                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                            }}
                            className="ant-border-space"
                            locale={{
                                emptyText: <Empty description="Data not found" />,
                            }}
                        />
                    </div>
                </Card>
        </>
    );
}

export default Index;